import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { getFetchURL } from "../helpers/actionHelpers";
const initialState = {
  companyLogin: {}
};


export const loginToCompany = createAsyncThunk("company/loginToCompany", async (apiData, { dispatch }) => {
  const options = {
    method: "POST",
    data: apiData,
    headers: {"Content-Type": "application/json"},
    url: getFetchURL("/company/login")
  };

  const response = await axios(options);
  return response.data;
});

export const companySlice = createSlice({
  name: "company",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginToCompany.fulfilled, (state, action) => {
        state.companyLogin = action.payload;
      })
  }
});

export default companySlice.reducer;
